
export const TOAST_MESSAGES = {
    STL_FETCH_FAILED: "Failed to fetch Materials.",
    STL_CREATE_FAILED: "Failed to create SAN",
};

export const STL_STATUS_VALUE_LABELS = [
    { value: "SUCCESS", label: "Success" },
    { value: "FAIL", label: "Fail" },
];

export const STL_STATUS = {
    SUCCESS: "SUCCESS",
    FAIL: "FAIL",
};


export const getSTLStatusColor = (status) => {
    switch (status) {
        case STL_STATUS.SUCCESS:
            return "bg-green-100 hover:bg-green-200 transition-colors text-green-700";
        case STL_STATUS.FAIL:
            return "bg-red-50 hover:bg-red-150 transition-colors text-red-500";
        default:
            return "bg-white transition-colors text-black"; 
    }
};

export const STL_COLUMNS = [
    "product_name",
    "warehouse_name",
    "entity_type",
    "date",
    "transaction_type",
    "before_quantity",
    "demanded_quantity",
    "after_quantity",
    "status",
    "error_message",
    "initiated_by_name",
];

export const STL_LABELS = {
    product_name: "Product Name",
    warehouse_name: "Warehouse Name",
    entity_type: "Entity Type",
    date: "Date",
    transaction_type: "Transaction Type",
    before_quantity: "Before Quantity",
    demanded_quantity: "Demanded Quantity",
    after_quantity: "After Quantity",
    status: "Status",
    error_message: "Error",
    initiated_by_name: "Initiated By",
};
